module.exports = __webpack_public_path__ + "img/btn_mic_off.97a41a56.png";